import React, { useState } from 'react';
import { API_BASE } from '../../config';
import { useTranslation } from '../../translations';
import { useToast } from '../ui/Toast';
import { useConfirm } from '../ui/Modal';
import { formatDateTime } from '../../utils/format';
import { godzinyPoPrzypomnieniuWidgetu } from '../../utils/terminWplaty';

// Termin wpłaty zaliczki w szczegółach rezerwacji (FAZA F, F.6). Pokazywany, dopóki serwer go
// pilnuje (zaliczka nieopłacona, bez pieniędzy na rezerwacji). Usunąć go można na każdym planie
// (POST /api/payments/remove-deadline): po zejściu z Premium firma musi móc zrezygnować
// z automatycznego anulowania ustawionego wcześniej. `bezEmaila`: sweep wysyła przypomnienie tylko
// mailem, więc klient bez adresu go nie dostanie i ramka nie może go obiecywać. `oknoWidgetu`
// (`widget_cancel_hours` wiersza): rezerwacja z widgetu po usunięciu terminu wraca do reguły widgetu,
// więc okno potwierdzenia nie może mówić, że nie zostanie anulowana (przegląd pakietu 3b).
export default function PaymentDeadlineInfo({ reservationId, termin, onRemoved, bezEmaila = false, oknoWidgetu = null }) {
  const { t, currentLanguage } = useTranslation();
  const toast = useToast();
  const confirm = useConfirm();
  const [usuwanie, setUsuwanie] = useState(false);
  if (!termin) return null;

  const usun = async () => {
    if (usuwanie) return;
    const godzinyWidgetu = godzinyPoPrzypomnieniuWidgetu(oknoWidgetu);
    const ok = await confirm({
      title: t('paymentDeadline.removeConfirmTitle'),
      message: godzinyWidgetu
        ? t('paymentDeadline.removeConfirmMessageWidget', { hours: godzinyWidgetu })
        : t('paymentDeadline.removeConfirmMessage'),
      confirmLabel: t('paymentDeadline.remove'),
      tone: 'danger',
    });
    if (!ok) return;
    setUsuwanie(true);
    try {
      const csrf = localStorage.getItem('csrfToken') || '';
      const r = await fetch(`${API_BASE}/api/payments/remove-deadline`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'x-csrf-token': csrf },
        body: JSON.stringify({ reservation_id: reservationId }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.error || t('paymentDeadline.removeError'));
      toast.success(t('paymentDeadline.removed'));
      if (typeof onRemoved === 'function') onRemoved();
    } catch (e) {
      toast.error(e.message || t('paymentDeadline.removeError'));
    } finally {
      setUsuwanie(false);
    }
  };

  return (
    <div
      data-cy="payment-deadline-info"
      style={{ marginTop: 8, padding: '8px 10px', border: '1px solid var(--warning-border)', borderRadius: 8, background: 'var(--warning-bg)', color: 'var(--text)', fontSize: '0.8rem', lineHeight: 1.45, maxWidth: 320 }}
    >
      <div style={{ fontWeight: 700 }}>
        {t('paymentDeadline.infoTitle', { date: formatDateTime(termin, { locale: currentLanguage }) })}
      </div>
      <div style={{ color: 'var(--text-muted)' }} data-cy="payment-deadline-info-text">
        {t(bezEmaila ? 'paymentDeadline.infoNoEmail' : 'paymentDeadline.info')}
      </div>
      <button
        type="button"
        onClick={usun}
        disabled={usuwanie}
        data-cy="payment-deadline-remove"
        style={{ marginTop: 6, padding: '6px 10px', border: '1px solid var(--input-border)', borderRadius: 8, background: 'transparent', color: 'var(--text)', fontWeight: 600, fontSize: '0.78rem', cursor: usuwanie ? 'wait' : 'pointer' }}
      >
        {usuwanie ? t('paymentDeadline.removing') : t('paymentDeadline.remove')}
      </button>
    </div>
  );
}
